import sendRequest from "./send-request";
// const BASE_URL = "http://localhost:3000/api/about";
const BASE_URL = "/api/about";


export async function getAgents()
{
    return sendRequest(BASE_URL);
}